const AccountIcon = () => {
  return (
    <div>
      <svg
        width='23'
        height='23'
        viewBox='0 0 23 23'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#clip0_808_3141)'>
          <path
            d='M18.2097 19.6324V18.9184C18.2097 17.8863 17.6567 16.9337 16.7607 16.422L13.6758 14.6567'
            stroke='white'
            strokeWidth='2'
            strokeMiterlimit='10'
          />
          <path
            d='M9.32301 14.6548L6.24197 16.422C5.34593 16.9337 4.79297 17.8863 4.79297 18.9184V19.6324'
            stroke='white'
            strokeWidth='2'
            strokeMiterlimit='10'
          />
          <path
            d='M11.5013 15.3333C9.38434 15.3333 7.66797 13.617 7.66797 11.5V9.58333C7.66797 7.46637 9.38434 5.75 11.5013 5.75C13.6183 5.75 15.3346 7.46637 15.3346 9.58333V11.5C15.3346 13.617 13.6183 15.3333 11.5013 15.3333Z'
            stroke='white'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='square'
          />
          <path
            d='M11.5007 22.0416C17.3227 22.0416 22.0423 17.3219 22.0423 11.4999C22.0423 5.67792 17.3227 0.958252 11.5007 0.958252C5.67865 0.958252 0.958984 5.67792 0.958984 11.4999C0.958984 17.3219 5.67865 22.0416 11.5007 22.0416Z'
            stroke='white'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='square'
          />
        </g>
        <defs>
          <clipPath id='clip0_808_3141'>
            <rect width='23' height='23' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}

export default AccountIcon
